import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table-wrapper" }
const _hoisted_2 = { class: "table table-bordered" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "sticky-col" }
const _hoisted_5 = {
  class: "font-italic pointer",
  title: "Dated labels align project periods (e.g., months, quarters, or years) with calendar dates based on the project start date."
}
const _hoisted_6 = { class: "sticky-col" }
const _hoisted_7 = { class: "sticky-col" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "sticky-col" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }

import { computed } from 'vue'

    import type { ColumnReadModel, ValueSerieReadModel } from '@Quest/_Common/readmodels'
    import type { MonthYear } from '@common/types'
    import { MonthYearHelpers } from '@common/types'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ValueSeriesTable',
  props: {
    propTitle: {},
    propSeries: {},
    propColumns: {},
    propStartDate: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- computed (replacing getters) ----------------

    const title = computed(() => props.propTitle ?? '')
    const series = computed(() => props.propSeries)
    const columns = computed(() => props.propColumns)
    const startDate = computed<MonthYear | null>(() => props.propStartDate ?? null)

    const totalSerie = computed(() =>
        series.value.find(s => s.IsTotal)
    )

    const regularSeries = computed(() =>
        series.value.filter(s => !s.IsTotal)
    )

    const startDateLabel = computed<string | null>(() =>
        MonthYearHelpers.toMonthYearLongString(startDate.value)
    )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", null, [
          (startDate.value)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                _createElementVNode("td", _hoisted_4, [
                  _cache[0] || (_cache[0] = _createTextVNode(" Start date: ", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(startDateLabel.value), 1 /* TEXT */)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: _normalizeClass(["period-col", col.CssClass]),
                    key: col.Index
                  }, _toDisplayString(col.DatedLabel), 3 /* TEXT, CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_6, _toDisplayString(title.value), 1 /* TEXT */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
              return (_openBlock(), _createElementBlock("th", {
                class: "period-col",
                key: col.Index
              }, _toDisplayString(col.Label), 1 /* TEXT */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regularSeries.value, (s) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: s.Id
            }, [
              _createElementVNode("td", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(s.Name), 1 /* TEXT */),
                (s.Unit)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "[" + _toDisplayString(s.Unit) + "]", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
                return (_openBlock(), _createElementBlock("td", {
                  class: "period-col",
                  key: col.Index
                }, [
                  _createElementVNode("span", null, _toDisplayString(s.FormattedValues[col.Index]), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        (totalSerie.value)
          ? (_openBlock(), _createElementBlock("tfoot", _hoisted_9, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(totalSerie.value.Name), 1 /* TEXT */),
                  (totalSerie.value.Unit)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "[" + _toDisplayString(totalSerie.value.Unit) + "]", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: "period-col",
                    key: col.Index
                  }, [
                    _createElementVNode("span", null, _toDisplayString(totalSerie.value.FormattedValues[col.Index]), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              (totalSerie.value.ShowGrowthValues)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _cache[1] || (_cache[1] = _createElementVNode("th", { class: "sticky-col" }, " % Growth ", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
                      return (_openBlock(), _createElementBlock("td", {
                        class: "period-col",
                        key: col.Index
                      }, [
                        _createElementVNode("span", null, _toDisplayString(totalSerie.value.FormattedGrowthValues[col.Index]), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}
}

})